<template>
    <page>
        <module :title="title">
            <c-form ref="form">
                <c-form ref="editForm">
		                <c-form-column>
                            <c-form-item type="editor" label="内容" name="content" required></c-form-item>
		                </c-form-column>
                </c-form>
            </c-form>

            <template slot="button">
                <c-button  size="m" @click="save()">保存</c-button>
            </template>
        </module>
    </page>
</template>

<script>
    export default {
        name: 'm_recruit_brief',

        components: {
        },

        props: {
            languageType: Number        //2=英文  1=中文
        },

        computed:{

        },

        watch:{
            languageType(){
                this.title = (this.languageType==1?'中文':'英文')+'人才理念'
            }
        },

        data() {
            return {
                title:'人才理念'
            }
        },

        mounted() {
	        this.getDetail();
        },

        methods: {
            getDetail() {
                this.request({
                    url: this.languageType==2?'/website/recruit_en/brief/detail':'/website/recruit/brief/detail',
                    data: {},
                    loading: true,
                    success: data => {
	                    if (data){
		                    var formObj = JSON.parse(data);
		                    this.$refs.editForm.set(formObj);
	                    }
                    }
                });
            },

            save() {
                this.$refs.editForm.submit({
                    url: this.languageType==2?'/website/recruit_en/brief/edit':'/website/recruit/brief/edit',
                    rule: {
                        content:'请输入内容信息'
                    },
                    dataFormatter: data => {
						var submitObj = {};
	                    submitObj.control_configure = JSON.stringify(data)
                        return submitObj;
                    },
                    success: () => {
                        this.$message({
                            text: '保存成功',
                            icon: 'success'
                        });
                    }
                });
            },
        }
    }
</script>

<style lang="stylus" scoped>
  .invoice-list {
    .item {
      box-sizing: border-box;
      width: 360px;
      height: 360px;
      padding: 10px 15px;
      margin-right: 26px;
      margin-bottom: 26px;
      background: #F9F9F9;

      p {
        padding: 5px 0;
        line-height: 20px;
        font-size: 13px;
        color: #333;
      }

      .handle {
        margin-top: 20px;
        text-align: right;

        a {
          margin-left: 15px;
          font-size: 16px;
          color: #666;
        }
      }
    }

    .add {
      box-sizing: border-box;
      width: 360px;
      height: 360px;
      border: 1px dashed #ddd;
      font-size: 50px;
      color: #ccc;
      cursor: pointer;

      &:hover {
        theme-border(main);
        theme-color(main);
      }
    }
  }
</style>